/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Luned\xEC", "Marted\xEC", "Mercoled\xEC", "Gioved\xEC", "Venerd\xEC", "Sabato", "Domenica"], a = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"], o = "Anni", t = "Anno", n = "Mese", s = "Settimana", r = "Giorno", d = "Oggi", i = "Nessun evento", l = "Tutto il giorno", M = "Cancella", m = "Crea evento", v = "dddd D MMMM YYYY", g = { weekDays: e, months: a, years: "Anni", year: "Anno", month: "Mese", week: "Settimana", day: "Giorno", today: "Oggi", noEvent: "Nessun evento", allDay: "Tutto il giorno", deleteEvent: "Cancella", createEvent: "Crea evento", dateFormat: "dddd D MMMM YYYY" };
export {
  l as allDay,
  m as createEvent,
  v as dateFormat,
  r as day,
  g as default,
  M as deleteEvent,
  n as month,
  a as months,
  i as noEvent,
  d as today,
  s as week,
  e as weekDays,
  t as year,
  o as years
};
